import Vue from "vue";
import App from "./App.vue";
import router from "./router";

Vue.config.productionTip = false;

new Vue({
  router,
  data: {
    api: 'https://n0l6uyv33d.execute-api.us-east-1.amazonaws.com/Prod/'
  },
  render: h => h(App)
}).$mount("#app");
